import { api } from '../../config';
import {
  PROFILE_IMAGE_UPLOAD_ERROR,
  PROFILE_IMAGE_UPLOAD_START,
  PROFILE_IMAGE_UPLOAD_SUCCESS
} from '../../constants/index';
import { uploadProfileImageMutation } from '../../lib/graphql';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { setLoaderComplete, setLoaderStart } from '../loader/loader';
import axios from 'axios';

const uploadProfileImage = (id, fileName, oldFile) => {

  return async (dispatch, getState, { client }) => {

    try {
      dispatch({
        type: PROFILE_IMAGE_UPLOAD_START
      })
    
      const { data } = await client.mutate({
        mutation: uploadProfileImageMutation,
        variables: {
          userId: id,
          picture: fileName
        }
      })

      if (data?.uploadProfileImage?.status == "200") {
        dispatch({
          type: PROFILE_IMAGE_UPLOAD_SUCCESS
        });
        showToaster({ messageId: 'updateProfileSuccess', toasterType: 'success' });
      } else {
        dispatch({
          type: PROFILE_IMAGE_UPLOAD_ERROR
        });
        showToaster({ messageId: 'commonError', toasterType: 'error' });
      }
    } catch (err) {
      dispatch({
        type: PROFILE_IMAGE_UPLOAD_ERROR
      })
    }
  }
}

export default uploadProfileImage;